// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_TmQ","cls2":"common-cls2_Vc4 common-cls1_TmQ"};